var _Defs, _Text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, Text, TSpan } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgFreeBetPlaceholder(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "freeBetPlaceholder_svg__Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.53 21.67"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)), _Text || (_Text = /*#__PURE__*/React.createElement(Text, {
    transform: "translate(0 8.37)",
    fill: "#8e8d9c",
    fontSize: 10,
    id: "freeBetPlaceholder_svg__Tips_-_RTV_Tipsters",
    "data-name": "Tips - RTV Tipsters"
  }, /*#__PURE__*/React.createElement(TSpan, {
    x: 0,
    y: 0,
    letterSpacing: 0
  }, "B"), /*#__PURE__*/React.createElement(TSpan, {
    className: "freeBetPlaceholder_svg__cls-1",
    x: 5.44,
    y: 0
  }, "oo"), /*#__PURE__*/React.createElement(TSpan, {
    x: 16.38,
    y: 0,
    letterSpacing: ".01em"
  }, "k"), /*#__PURE__*/React.createElement(TSpan, {
    className: "freeBetPlaceholder_svg__cls-1",
    x: 21.22,
    y: 0
  }, "ie"), /*#__PURE__*/React.createElement(TSpan, {
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement(TSpan, {
    x: 4.84,
    y: 10.8
  }, "logo")))));
}
export default SvgFreeBetPlaceholder;